import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import ImgNonEditQB from "./ImgNonEditQB";
import McqNonEditQB from "./McqNonEditQB";
import axios from "../../../axios";
import PrintHomeWorkQs from "../../../Homework/pages/On_going/Published/Published_Q_list/PrintHomeWorkQs";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Paper,
  Typography,
  Chip,
  CircularProgress,
} from "@mui/material";
import {
  ArrowLeft,
  Edit3,
  FileDown,
  ListChecks,
  Award,
  FolderOpen,
  AlertTriangle,
} from "lucide-react";

const ACCENT = "#f77f00";
const ACCENT_SOFT = "#fff4e5";
const BORDER = "#e6e9ef";
const TEXT_PRIMARY = "#1f2733";
const TEXT_SECONDARY = "#5b6472";

export default function ScheduleQListQB() {
  const [QBName, setQBName] = useState("");
  const [QBSName, setQBSName] = useState("");
  const [data, setData] = useState([]);
  const [b4sQSTitle, setB4sQSTitle] = useState("");
  const [b4sQSSubject, setB4sQSSubject] = useState("");
  const [b4squestion, setB4squestion] = useState([]);
  const [questionType, setQuestionType] = useState("");
  const [qestionBankQs, setQestionBankQs] = useState([]);
  const [showUnsavedPrompt, setShowUnsavedPrompt] = useState(false);
  const [pendingNav, setPendingNav] = useState(false);
  const [isPdfLoading, setIsPdfLoading] = useState(false);
  const [assessment, setAssessment] = useState(null);

  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleQB = async () => {
      try {
        let res;
        if (state?.b4sid) {
          res = await axios.get(`/api/v1/b4sQuestion/get/${state?.b4sid}`);
          setB4sQSTitle(res.data.data?.title);
          setB4sQSSubject(res.data.data?.subject?.b4sSubjectName);
          setB4squestion(() => [res.data.data]);
        } else if (state?.qsbid) {
          res = await axios.get(`/api/v1/questionbank/getById/${state?.qsbid}`);
          setData(res.data.data?.questions);
          setQestionBankQs(res.data.data);
          setAssessment(res.data.data); // Saving for header details
        }
        setQuestionType(res.data.message.slice(0, 12));
        setQBName(res?.data?.data?.name);
        setQBSName(res?.data?.data?.subject_id?.name);
      } catch (err) {
        console.log(err);
      }
    };
    handleQB();
  }, []);

  const handleNavClick = () => {
    const localSaved = localStorage.getItem(`DraftQBLocal-${state.qsbid}`);
    if (localSaved) {
      setShowUnsavedPrompt(true);
      setPendingNav(true);
    } else {
      navigate("/editQuestionBank", {
        state: {
          b4sid: state?.b4sid,
          qsbid: state?.qsbid,
        },
      });
    }
  };

  // 🔥 FIX: Helper function to check if question is manually graded (Short/Descriptive)
  const isManuallyGraded = (question) => {
    return (
      question?.type_id?.isManuallyGraded === true ||
      question?.type?.is_manually_graded === true ||
      question?.type_id?.name?.toLowerCase().includes("short") ||
      question?.type_id?.name?.toLowerCase().includes("descriptive") ||
      question?.type_id?.name?.toLowerCase().includes("long")
    );
  };

  const backPath = "/questionLibrary"; // Jahan se aaya hai

  return (
    <>
      {data || b4squestion ? (
        <>
          {/* Header Card */}
          <Paper
            elevation={0}
            sx={{
              p: 2,
              mb: 2,
              mt: 1,
              mx: 1,
              borderRadius: "14px",
              border: `1px solid ${BORDER}`,
              background: "linear-gradient(135deg, #fff8f0 0%, #fff5e6 100%)",
            }}
          >
            {/* Breadcrumb */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.75,
                mb: 1.25,
                flexWrap: "wrap",
              }}
            >
              <Link
                to={backPath}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  color: ACCENT,
                  textDecoration: "none",
                }}
              >
                <ArrowLeft size={16} />
              </Link>
              <Link to={backPath} style={{ textDecoration: "none" }}>
                <Typography
                  sx={{
                    fontSize: "12.5px",
                    color: TEXT_SECONDARY,
                    fontWeight: 500,
                  }}
                >
                  Question Bank
                </Typography>
              </Link>
              <Typography sx={{ fontSize: "12.5px", color: TEXT_SECONDARY }}>
                /
              </Typography>
              <Typography
                sx={{
                  fontSize: "12.5px",
                  color: ACCENT,
                  fontWeight: 700,
                  maxWidth: 420,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                title={QBName || b4sQSTitle}
              >
                {QBName || b4sQSTitle}
              </Typography>
            </Box>

            {/* Title + Action Buttons */}
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 1.5,
              }}
            >
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: 700,
                    color: TEXT_PRIMARY,
                    letterSpacing: "-0.3px",
                    lineHeight: 1.3,
                  }}
                >
                  {QBName || b4sQSTitle}
                </Typography>

                {/* Chips row */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mt: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <Chip
                    icon={<FolderOpen size={12} color={ACCENT} />}
                    label={QBSName || b4sQSSubject || "Subject"}
                    size="small"
                    sx={{
                      background: "#fff",
                      color: TEXT_PRIMARY,
                      fontWeight: 600,
                      fontSize: "11.5px",
                      border: `1px solid ${BORDER}`,
                      "& .MuiChip-icon": { ml: "6px", color: ACCENT },
                    }}
                  />
                  <Chip
                    icon={<ListChecks size={12} color={ACCENT} />}
                    label={`${assessment?.questions?.length || 0} Questions`}
                    size="small"
                    sx={{
                      background: ACCENT_SOFT,
                      color: ACCENT,
                      fontWeight: 700,
                      fontSize: "11px",
                      border: `1px solid ${ACCENT}`,
                      "& .MuiChip-icon": { ml: "6px", color: ACCENT },
                    }}
                  />
                  <Chip
                    icon={<Award size={12} color={ACCENT} />}
                    label={`${assessment?.questions?.reduce((acc, q) => acc + (Number(q.correct_score) || 0), 0) || 0} Marks`}
                    size="small"
                    sx={{
                      background: ACCENT_SOFT,
                      color: ACCENT,
                      fontWeight: 700,
                      fontSize: "11px",
                      border: `1px solid ${ACCENT}`,
                      "& .MuiChip-icon": { ml: "6px", color: ACCENT },
                    }}
                  />
                </Box>
              </Box>

              {/* Action Buttons */}
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                {questionType === "QuestionBank" && (
                  <Button
                    startIcon={<Edit3 size={15} />}
                    onClick={handleNavClick}
                    variant="contained"
                    sx={{
                      background: ACCENT,
                      color: "#fff",
                      borderRadius: "10px",
                      textTransform: "none",
                      fontWeight: 700,
                      fontSize: "13px",
                      px: 2.25,
                      py: 0.85,
                      boxShadow: "0 4px 12px rgba(247,127,0,0.25)",
                      "&:hover": {
                        background: "#e56f00",
                        boxShadow: "0 6px 16px rgba(247,127,0,0.35)",
                      },
                    }}
                  >
                    Edit
                  </Button>
                )}

                <Button
                  startIcon={
                    isPdfLoading ? (
                      <CircularProgress size={16} color="inherit" />
                    ) : (
                      <FileDown size={15} />
                    )
                  }
                  onClick={async () => {
                    setIsPdfLoading(true);
                    try {
                      await PrintHomeWorkQs(
                        qestionBankQs,
                        true,
                        "QuestionBank",
                      );
                    } finally {
                      setIsPdfLoading(false);
                    }
                  }}
                  variant="outlined"
                  disabled={isPdfLoading}
                  sx={{
                    borderColor: ACCENT,
                    color: ACCENT,
                    borderRadius: "10px",
                    textTransform: "none",
                    fontWeight: 700,
                    fontSize: "13px",
                    px: 2.25,
                    py: 0.85,
                    "&:hover": {
                      background: ACCENT_SOFT,
                      borderColor: ACCENT,
                    },
                  }}
                >
                  {isPdfLoading ? "Generating..." : "Export to PDF"}
                </Button>
              </Box>
            </Box>
          </Paper>

          {/* Questions List */}
          <Box
            className="orange-scrollBar"
            sx={{
              mx: 1,
              pb: 2,
              maxHeight: "calc(100vh - 260px)",
              overflowY: "auto",
            }}
          >
            {data.map((question, index) => {
              // 🔥 FIX: Type based rendering (options par nahi)
              if (isManuallyGraded(question)) {
                return (
                  <ImgNonEditQB
                    key={index}
                    data={question}
                    questionNo={index + 1}
                  />
                );
              } else {
                return (
                  <McqNonEditQB
                    key={index}
                    data={question}
                    questionNo={index + 1}
                  />
                );
              }
            })}

            {b4squestion?.length > 0 &&
              b4squestion.map((question, index) => {
                const newIndex = data.length + index + 1;
                if (isManuallyGraded(question)) {
                  return (
                    <ImgNonEditQB
                      key={newIndex}
                      data={question}
                      questionNo={newIndex}
                    />
                  );
                } else {
                  return (
                    <McqNonEditQB
                      key={newIndex}
                      data={question}
                      questionNo={newIndex}
                    />
                  );
                }
              })}
          </Box>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <img
            className="qList_loader"
            src="/gif/LoaderDot.gif"
            alt="Loading"
          />
        </Box>
      )}

      {/* Unsaved changes dialog (Assessment style) */}
      <Dialog
        open={showUnsavedPrompt}
        onClose={() => setShowUnsavedPrompt(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px", p: 1 } }}
      >
        <DialogTitle sx={{ textAlign: "center", pt: 3 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              background: "#fff8e1",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mx: "auto",
              mb: 2,
            }}
          >
            <AlertTriangle size={28} color="#f59e0b" />
          </Box>
          <Typography
            sx={{ fontSize: "18px", fontWeight: 800, color: TEXT_PRIMARY }}
          >
            Unsaved Changes Found
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography
            sx={{
              fontSize: "13.5px",
              color: TEXT_SECONDARY,
              textAlign: "center",
              lineHeight: 1.6,
            }}
          >
            You already have unsaved changes for this draft. Do you want to
            restore them or start fresh?
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            p: 3,
            pt: 1,
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <Button
            fullWidth
            variant="contained"
            onClick={() => {
              setShowUnsavedPrompt(false);
              navigate("/editQuestionBank", {
                state: {
                  b4sid: state?.b4sid,
                  qsbid: state?.qsbid,
                  localData: true,
                },
              });
            }}
            sx={{
              background: ACCENT,
              color: "#fff",
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 700,
              py: 1,
              boxShadow: "0 4px 12px rgba(247,127,0,0.25)",
              "&:hover": { background: "#e56f00" },
            }}
          >
            Restore Saved Changes
          </Button>

          <Box sx={{ display: "flex", width: "100%", gap: 1.5 }}>
            <Button
              fullWidth
              variant="outlined"
              onClick={() => setShowUnsavedPrompt(false)}
              sx={{
                borderColor: BORDER,
                color: TEXT_SECONDARY,
                borderRadius: "10px",
                textTransform: "none",
                fontWeight: 600,
                "&:hover": {
                  background: "#f8f9fb",
                  borderColor: TEXT_SECONDARY,
                },
              }}
            >
              Cancel
            </Button>
            <Button
              fullWidth
              variant="outlined"
              color="error"
              onClick={() => {
                localStorage.removeItem(`DraftQBLocal-${state.qsbid}`);
                setShowUnsavedPrompt(false);
                navigate("/editQuestionBank", {
                  state: {
                    b4sid: state?.b4sid,
                    qsbid: state?.qsbid,
                  },
                });
              }}
              sx={{
                borderRadius: "10px",
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Ignore & Start Fresh
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
}
